export enum TournamentTypes {
    Available,
    Participated,
    Owned,
    Completed,
    Current,
}